<div class="container-fluid" [@fadeInAnimation]>
  <div class="row">
    <div class="col-xl-3 col-lg-2"></div>
    <div class="col-xl-6 col-lg-8">
      <div class="jumbotron">
        <h1 class="h3">{{ 'norge.kvittering.rubrik' | translate }}</h1>
        <div class="frontpage-text lead">
          {{ 'norge.kvittering.brodtext' | translate }}
        </div>
        <hr />
        <p class="mb-1">{{ 'norge.kvittering.referanse' | translate }}</p>
        <p class="h3 blue">{{ referenceNumber }}</p>
        <p>{{ 'norge.kvittering.referansetekst' | translate }}</p>
        <hr />
        <div class="row">
          <div class="col-md-3 col-lg-2"></div>
          <div class="col-md-6 col-lg-8">
            @if (summary) {
              <button type="button" class="btn-garanti btn-blue w-100 mt-4 mb-3" [attr.aria-expanded]="isSummaryOpen" (click)="isSummaryOpen = !isSummaryOpen">
                {{ (isSummaryOpen ? 'norge.kvittering.skjul-oppsummering' : 'norge.kvittering.vis-oppsummering') | translate }}
              </button>
            }
            <a routerLink="/no" class="btn-garanti btn-pink w-100 mb-0">
              {{ 'norge.kvittering.tilbake' | translate }}
            </a>
          </div>
        </div>
        @if (summary; as submittedSummary) {
          @if (isSummaryOpen) {
            <hr />
            <div class="card mb-3">
              <div class="card-body">
                <div class="form-field">
                  <label>{{ 'norge.soknad.valgt-sak' | translate }}</label>
                  <div>{{ submittedSummary.caseName }}</div>
                </div>
              </div>
            </div>
            @for (summarySection of submittedSummary.sections; track summarySection.titleKey) {
              <div class="card mb-3">
                <div class="card-header">{{ summarySection.titleKey | translate }}</div>
                <div class="card-body">
                  <div class="form-grid">
                    @for (summaryRow of summarySection.rows; track $index) {
                      <div class="form-field" [class.form-field-wide]="summaryRow.label.length > wideSummaryLabelLength">
                        <label>{{ summaryRow.label }}</label>
                        @for (summaryLine of summaryRow.lines; track $index) {
                          <div>{{ summaryLine }}</div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            @if (submittedSummary.attachmentNames.length > 0) {
              <div class="card mb-3">
                <div class="card-header">{{ 'norge.soknad.sektion.vedlegg' | translate }}</div>
                <div class="card-body">
                  @for (attachmentName of submittedSummary.attachmentNames; track $index) {
                    <div class="text-break">{{ attachmentName }}</div>
                  }
                </div>
              </div>
            }
            <hr />
            <div class="row">
              <div class="col-md-3 col-lg-2"></div>
              <div class="col-md-6 col-lg-8">
                <a routerLink="/no" class="btn-garanti btn-pink w-100 mb-0">
                  {{ 'norge.kvittering.tilbake' | translate }}
                </a>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>
